import { render, staticRenderFns } from "./CertificationVersionHistory.vue?vue&type=template&id=467b8aad&scoped=true&"
import script from "./CertificationVersionHistory.vue?vue&type=script&lang=js&"
export * from "./CertificationVersionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467b8aad",
  null
  
)

export default component.exports